<template>
  <v-sheet height="100%">
    <Slide3 />
    <v-dialog v-model="modalBoolean" width="85%">
      <v-card>
        <v-app-bar dark color="primary" :fixed="true">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modalBoolean = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-img
                v-for="asset in clickedItem.assets"
                :key="asset"
                :src="renderImage(asset)"
                eager
              >
              </v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- External url notification modal -->
    <v-dialog
        v-model="showUrlModal"
        :width="$vuetify.breakpoint.mobile ? `90%` : `50%`"
        style="min-height: 50% !important;"
      >
        <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            You are about to leave this page
          </v-toolbar-title>
        </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12" class="text-center">
                <div>
                  <p class="text-justify help reminder">
                  This will take you to an external website and/or open a new window or tab, but the current window will remain opened. Proceed?
                  </p>
                  <p>
                    <v-btn
                      tile
                      color="success"
                      @click="openUrl"
                    >
                      <v-icon left>
                        mdi-check
                      </v-icon>
                      OK
                    </v-btn>
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
  </v-sheet>
</template>

<script>
import Slide3 from "../../public/static/Slide 3/EnvironmentalImpacts.svg";
import svgMixin from "@/mixins/svgMixin.js";

export default {
  name: "EnvironmentalImpacts",
  components: {
    Slide3
  },
  mixins: [svgMixin(3, ".slide3", "slide3.js")],
  data() {
    return {
      modalBoolean: false,
      clickedItem: "",
      showUrlModal: false
    };
  },
  methods: {
    closeModal() {
      this.currentStation = null;
    },
    openUrl() {
      window.open("https://gdot.maps.arcgis.com/sharing/rest/content/items/ad4ccafeb8fe44cc86a2a897da120171/data", 'a_blank'),
      this.showUrlModal = false
    }
  }
};
</script>
<style>
.mouse {
  cursor: pointer;
}
</style>
